import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62b3bd17"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close-img",
  src: "media/svg/close-icon-5.svg",
  alt: ""
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "bounce" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "p-modal-overlay",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close-modal')))
      }, [
        _createElementVNode("div", {
          class: "p-modal",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-modal')))
          }, _hoisted_2),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ]),
    _: 3
  }))
}